/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ template: NonNullable<unknown> }} Template_Apply_ErrorInputs */

const en_template_apply_error = /** @type {(inputs: Template_Apply_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The template “${i?.template}” could not be applied.`)
};

const de_template_apply_error = /** @type {(inputs: Template_Apply_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Vorlage „${i?.template}“ konnte nicht angewendet werden.`)
};

/**
* | output |
* | --- |
* | "The template “{template}” could not be applied." |
*
* @param {Template_Apply_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_error = /** @type {((inputs: Template_Apply_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_error(inputs)
	return de_template_apply_error(inputs)
});